<template>
<div>
    <div v-show="!isEditing">
        <div>
            <div class="card-header">
                <p class="card-header-title">{{ data.name }}</p>
            </div>
            <footer class="card-footer">
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
            </footer>
        </div>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit Notification</p>
        </div>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <div class="control">
                        <input class="input is-success" type="text" placeholder="Name" v-model="data.name">
                    </div>
                </div>

                <div class="field">
                    <div class="control">
                        <b-select id="restrictAwardBy" name="restrictAwardBy" v-model="data.restrictAwardBy">
                            <option selected value="1">Used by everyone</option>
                            <option value="2">Used only by class teachers</option>
                            <option value="3">Used only by selected teachers</option>
                        </b-select>
                    </div>
                </div>

                <div class="field" v-show="data.restrictAwardBy == 3">
                    <div class="control">
                        <multiselect v-model="data.restrictAwardTo" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="_id" placeholder="Teachers that can use this behavior" v-show="data.restrictAwardBy == 3"></multiselect>
                    </div>
                </div>

                <div class="field">
                    <div class="control">
                        <compact-picker v-model="data.colour" :palette="palette" />
                    </div>
                </div>

                <div class="field">
                    <div class="control">
                        <input class="input is-success" type="text" placeholder="Optional details about the behavior" v-model="data.info">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Is remarks mandatory for this behavior?</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" v-model="data.isRemarksMandatory" value="0" checked>
                            No
                        </label>
                        <label class="radio">
                            <input type="radio" v-model="data.isRemarksMandatory" value="1">
                            Yes
                        </label>
                    </div>
                </div>
            </div>

            <div class="field">
                <b-radio v-model="data.status" native-value="1">
                    Active
                </b-radio>
                <b-radio v-model="data.status" native-value="0">
                    Inactive
                </b-radio>
            </div>

                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(data)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'
import Multiselect from 'vue-multiselect'
import { Compact } from 'vue-color'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    props: ['data'],
    components:{
        Multiselect,
        Loading,
        'compact-picker': Compact,
    },
    data() {
        return {
            initialSelectedColour : "",
            listTeachers: [{
                _id: '',
                firstName: ''
            }],
            palette : ['#f3052c', '#ee15c3', '#b90bde','#8208f4','#1e08f4','#0898f4','#08ecf4','#08f498','#08f43f','#f5ed07','#f59e07','#f56007','#f52307','#000000'],
            isEditing: false
        };
    },
    created() {
        this.getTeacherList();
        this.initialSelectedColour = this.data.colour
    },
    methods: {
        getTeacherList(){
            let self = this;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            this.$emit('update-data', data);
            this.isEditing = false;
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Manage/Notifications/DataViewParents.vue